// extracted by mini-css-extract-plugin
module.exports = {"menuContainer":"menu_menuContainer__3-9U-","formContainer":"menu_formContainer__Frlkz","checkboxContainer":"menu_checkboxContainer__gM4RM"};